export enum ElectricHingeLocation {
    TOP = 'Top Hinge',   
    TOP2 = 'Second Hinge from Top',
    TOP3 = 'Third Hinge from Top',
    TOP4 = 'Fourth Hinge from Top',
    Bottom =  'Bottom Hinge',
  }